import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player/lazy";
import { Modal, Input, Alert } from "reactstrap";
import API from "../utils";
import axios from "axios";
import Loader from "../components/common/Loader";
import defalutimages from "../assets/images/user/user_default.jpg";
import { IoMdShare } from "react-icons/io";
import SharereelModal from "../components/reels/shareModal";
import { useParams } from "react-router-dom";

const Reel = () => {
  console.log("Reel component");
  const { id } = useParams(); // Get the ID from the URL

  const [reelData, setReelData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newComment, setNewComment] = useState("");
  const [showShareModal, setShowShareModal] = useState(false); // Move this hook here
  const token = localStorage.getItem("token");
  const { BASE_URL, ENDPOINTS } = API;
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const showError = (message) => {
    setErrorMessage(message);
    setTimeout(() => setErrorMessage(""), 5000);
  };

  const fetchReel = async () => {
    setLoading(true);
    console.log("fetchReel");
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
      };

      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      const response = await axios.get(`${BASE_URL}reel/${id}`, {
        headers,
      });
      if (response.data.status && response.data.payload) {
        const payload = response.data.payload;
        const reel = {
          id: payload.id,
          posted_by: payload.posted_by,
          url: payload.video_links[0],
          description: payload.title,
          pet_name: payload.posted_user.pet_name,
          name: payload.posted_user.name,
          profile_img: payload.posted_user.profile_img,
          likes: payload.like_comment_count.like,
          comments: payload.like_comment_count.comment,
          commentList: [],
          is_liked_by_user: payload.is_liked_by_user,
        };
        setReelData(reel);
      } else {
        showError("Failed to load reel data. Please try again later.");
      }
    } catch (error) {
      console.error("Error fetching reels:", error);
      showError("An error occurred while loading the reel. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReel();
  }, [id]);

  if (loading) {
    return <Loader />;
  }

  // Handle like count
  const likeReel = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}${ENDPOINTS.likescomments}`,
        { post_id: id, type: "like" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status) {
        const { is_liked_by_user, like_comment_count } =
          response?.data?.payload?.posts_details;
        setReelData((prevReelData) => ({
          ...prevReelData,
          is_liked_by_user: is_liked_by_user,
          likes: like_comment_count?.like || prevReelData.likes + 1,
        }));
      } else {
        showError("Failed to like the reel. Please try again.");
      }
    } catch (error) {
      console.log("Error liking reel:", error);
      showError("An error occurred while liking the reel.");
    }
  };

  // Handle unlike count
  const unlikeReel = async (likeId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}${ENDPOINTS.likescomments}/${likeId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.status) {
        setReelData((prevReelData) => ({
          ...prevReelData,
          is_liked_by_user: null,
          likes: prevReelData.likes - 1,
        }));
      } else {
        showError("Failed to unlike the reel. Please try again.");
      }
    } catch (error) {
      console.log("Error unliking reel:", error);
      showError("An error occurred while unliking the reel.");
    }
  };

  const handleSubmitComment = async () => {
    if (newComment.trim() !== "") {
      try {
        await axios.post(
          `${BASE_URL}${ENDPOINTS.likescomments}`,
          {
            post_id: id,
            type: "comment",
            comment: newComment,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setReelData((prevReelData) => ({
          ...prevReelData,
          comments: prevReelData.comments + 1,
          commentList: [
            ...prevReelData.commentList,
            {
              text: newComment,
              userImage: null,
            },
          ],
        }));

        setNewComment("");
        setIsModalOpen(false);
      } catch (error) {
        console.log("Error posting comment:", error);
        showError("Failed to submit comment. Please try again.");
      }
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleAddComment = async () => {
    try {
      // Fetch comments for the selected reel
      const response = await axios.get(
        `${BASE_URL}${ENDPOINTS.likescomments}?post_id=${id}&type=comment`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        const comments = response.data.payload.map((comment) => ({
          text: comment.comment,
          userImage: comment.commented_user?.profile_img || defalutimages, // Use a default image if not available
          name: comment.commented_user?.pet_name, // Default name if not available
          createdAt: comment.created_at,
        }));

        setReelData((prevReelData) => ({
          ...prevReelData,
          commentList: comments,
        }));
      }
      setIsModalOpen(true);
    } catch (error) {
      console.log("Error fetching comments:", error);
      showError("Failed to get comments. Please try again.");
    }
  };

  const handleSharePost = () => {
    setShowShareModal(true);
  };

  const handleCloseShareModal = () => {
    setShowShareModal(false);
  };

  return (
    <div className="page-wrapper">
      <div className="page-body-wrapper">
        <div className="page-body">
          <div className="reels-wrapper">
            {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
            {loading ? (
              <Loader />
            ) : !reelData || Object.keys(reelData).length === 0 ? (
              <div className="no-data-message">
                <p>No reels available at the moment.</p>
              </div>
            ) : (
              <div className="reels-container">
                <div className="reels-list">
                  <div key={`${reelData.id}${Date.now()}`} className="active">
                    <ReactPlayer
                      url={reelData.url}
                      playing={true}
                      width="100%"
                      height={window.innerWidth < 768 ? "70vh" : "558px"}
                      loop={true}
                      controls={true}
                      // muted={true}
                    />
                    <div className="reel-info">
                      <div className="reel-user">
                        <a
                          href={`/user-profile-view/${reelData.posted_by}`}
                          className="d-flex"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={reelData.profile_img || defalutimages}
                            alt="avatar"
                            className="reel-avatar"
                          />
                          <p
                            className="reel-username ms-2"
                            style={{ color: "#fff" }}
                          >
                            {reelData.pet_name}
                          </p>
                        </a>
                      </div>
                      {/* <p className="reel-caption">{reel.description}</p> */}
                      <div className="reel-options">
                        <span
                          className="like-button"
                          onClick={() =>
                            token
                              ? reelData.is_liked_by_user
                                ? unlikeReel(reelData.is_liked_by_user)
                                : likeReel()
                              : alert(
                                  "Log in or register with xPets to like this reel!"
                                )
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill={reelData.is_liked_by_user ? "red" : "white"}
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                          </svg>
                          {reelData.likes}
                        </span>

                        <span
                          className="comment-button"
                          onClick={() =>
                            token
                              ? handleAddComment()
                              : alert(
                                  "Log in or register with xPets to leave a comment!"
                                )
                          }
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm0 14H4V4h16v12z" />
                          </svg>{" "}
                          {reelData.comments}
                        </span>
                        <span
                          className="share-button"
                          onClick={() =>
                            token
                              ? handleSharePost()
                              : alert("Log in or register with xPets to share!")
                          }
                        >
                          <IoMdShare
                            style={{ width: "24px", height: "24px" }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Comment Modal */}
            <Modal isOpen={isModalOpen} toggle={closeModal}>
              <div className="title d-flex justify-content-between">
                Comments
                <div
                  className="close-box"
                  onClick={closeModal}
                  style={{ cursor: "pointer" }}
                >
                  X
                </div>
              </div>
              <hr />
              <div className="contents">
                <div className="ossn-box-inner">
                  <div style={{ width: "100%", margin: "auto" }}>
                    <form className="ossn-form">
                      <fieldset>
                        <div className="main-comments-list">
                          {reelData.commentList.length === 0 ? (
                            <p>No comments available for this reel.</p>
                          ) : (
                            reelData.commentList.map((comment, index) => (
                              <>
                                <div
                                  key={index}
                                  className="comment-item d-flex align-items-start mb-2"
                                >
                                  <img
                                    src={comment.userImage}
                                    alt="user"
                                    className="comment-avatar"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                  <div className="ms-2">
                                    <p className="comment-name mb-1">
                                      <strong>{comment.name}</strong>
                                    </p>
                                    <p className="comment-text mb-1">
                                      {comment.text}
                                    </p>
                                  </div>
                                </div>
                                <hr />
                              </>
                            ))
                          )}
                        </div>

                        <Input
                          type="textarea"
                          placeholder="Add a comment"
                          value={newComment}
                          onChange={(e) => setNewComment(e.target.value)}
                        />
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
              <div className="control">
                <div className="controls my-2 float-end">
                  <a
                    href="javascript:void(0);"
                    onClick={handleSubmitComment}
                    className="btn btn-primary btn-sm ms-2"
                  >
                    Submit
                  </a>
                  <a
                    href="javascript:void(0);"
                    onClick={closeModal}
                    className="btn btn-default btn-sm ms-2"
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </Modal>

            <SharereelModal
              showModal={showShareModal}
              handleClose={handleCloseShareModal}
              post_id={id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reel;
